import React, { FC, useContext } from "react"
import { navigate } from "gatsby"
import { Icon } from "semantic-ui-react"
import styled from "styled-components"
import { SearchContext } from "../../context/SearchProvider"
import { screenSizes } from "model"

const Container = styled.div`
  height: 40px;
  flex: 1;
  margin-left: 20px;
  margin-right: 20px;
  max-width: 800px;
  display: flex;
  font-size: 0.9em;

  form {
    width: 100%;

    input {
      width: 90%;
      height: 40px;
      border: 1px solid #d8d8d8;
      border-right: none !important;
      flex: 1;
      border-radius: 0;

      &:focus + button {
        box-shadow: 0 0 3px #2faeaf;
        border: 1px solid #2faeaf;
      }
    }
  }

  button {
    width: 40px;
    height: 40px;
    background-color: white;
    border: 1px solid #d8d8d8;
  }

  i {
    margin: 0;
    //color: rgba(0, 0, 0, 0.8);
  }
`

const DesktopContainer = styled(Container)`
  button {
    position: relative;
  }

  @media (max-width: ${screenSizes.desktop}px) {
    display: none;
  }

  @media (min-width: ${screenSizes.desktop}px) {
    display: flex;
  }
`
const MobileContainer = styled(Container)`
  width: 100%;
  max-width: 100%;
  margin: 0;

  form {
    width: 100%;
    display: flex;
  }

  input {
    border-left: none;
    border-right: none;
  }

  @media (min-width: ${screenSizes.desktop}px) {
    display: none;
  }

  @media (max-width: ${screenSizes.desktop}px) {
    display: flex;
  }
`

const Button = styled.button`
  ${({ disabled }) =>
    disabled
      ? `
    i {
      color: rgba(0, 0, 0, .2);
    }
  `
      : "cursor: pointer;"}
`

interface Props {
  mobile?: boolean
}

const SearchBar: FC<Props> = ({ mobile }) => {
  const { search, setSearch } = useContext(SearchContext)
  const ContainerComponent = mobile ? MobileContainer : DesktopContainer

  return (
    <ContainerComponent>
      <form
        onSubmit={event => {
          event.preventDefault()
          if (search) {
            navigate(`/search?search=${search}`)
          }
        }}
      >
        <input
          type="text"
          placeholder={"Search for products, categories & brands.."}
          name="query"
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
        <Button type="submit">
          <Icon name="search" size="small" />
        </Button>
      </form>
    </ContainerComponent>
  )
}

export default SearchBar
